var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"CenterServerContainer"},[_c('ContentTop',{attrs:{"title":"场地服务人次排行榜","topOptionsProps":_vm.cityActiveOptionProps,"type":2}}),_c('div',{staticClass:"rank-list",staticStyle:{"margin-top":"21px"}},[_c('rank-list',{attrs:{"listHeight":292,"tableTitle":_vm.tableTitle,"list":_vm.areaData}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }